import Box from '@mui/material/Box';
import type { CSSProperties } from 'react';

interface Props {
  size?: number;
  color?: string;
  style?: CSSProperties;
  variant?: string;
}

export default function PaymentSvgIcon({ size = 20, color = 'currentColor', style }: Props) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        color,
        '& svg': {
          width: '100%',
          height: '100%',
          display: 'block'
        }
      }}
      style={style}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M19 3H5C2.243 3 0 5.243 0 8v8c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V8c0-2.757-2.243-5-5-5ZM5 5h14c1.654 0 3 1.346 3 3v1H2V8c0-1.654 1.346-3 3-3Zm14 14H5c-1.654 0-3-1.346-3-3v-5h20v5c0 1.654-1.346 3-3 3Zm-2-3c0 .552-.448 1-1 1h-2c-.552 0-1-.448-1-1s.448-1 1-1h2c.552 0 1 .448 1 1Zm-7 0c0 .552-.448 1-1 1H6c-.552 0-1-.448-1-1s.448-1 1-1h3c.552 0 1 .448 1 1Z"
        />
      </svg>
    </Box>
  );
}
